import { render, staticRenderFns } from "./UserEditor.vue?vue&type=template&id=4ca88e69&"
import script from "./UserEditor.vue?vue&type=script&lang=js&"
export * from "./UserEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports